"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupingString;
/*
Puts spaces inside the string, grouping its content
groups_arr : the groups lengths
*/
function groupingString(str, groups_arr) {
  let result = "";
  groups_arr.forEach(length => {
    result += str.slice(0, length);
    result += " ";
    str = str.slice(length);
  });
  return result.slice(0, result.length - 1);
}
